import { useToggleState } from '@cian/react-utils';

import { JSX } from 'react';

import { PublisherPhoneButtonContainer } from 'shared/components/PublisherPhoneButton';
import { DisplayPhonesOptions } from 'shared/components/PublisherPhoneButton/types';
import { useApplicationContext } from 'shared/context/ApplicationContext';
import { CardComplaintContextProvider } from 'shared/context/CardComplaintContext';
import { useCardOfferDataContext } from 'shared/context/CardContext';
import { usePrepareCardComplaintContext } from 'shared/hooks/usePrepareCardComplaintContext';
import { useListingLayoutIsShortSelector } from 'shared/store/clientSide/slices/listingLayout';
import { stopPropagation } from 'shared/utils/event/stopPropagation';
import { memoWithDisplayName } from 'shared/utils/memoWithDisplayName';

import { ChatButtonNarrowCard } from '../ChatButton';
import { ComplaintFlow } from '../ComplaintFlow';
import { ErrorLogContainer } from '../ErrorLogComponent';
import { JoinElectronicTradingButtonContainer } from '../JoinElectronicTradingButton';

import { ComplaintContainer } from './internal/components/Complaint';
import { FavoriteContainer } from './internal/components/Favorite';
import { More } from './internal/components/More';
import { MoreItemComplaintContainer } from './internal/components/MoreItems';

import styles from './Controls.css';

const displayPhonesOptions: DisplayPhonesOptions = {
  countToDisplay: 1,
  shouldDisplayWorkHours: false,
};

export const Controls = memoWithDisplayName(() => {
  const { config } = useApplicationContext();
  const complaintContextValue = usePrepareCardComplaintContext();
  const isShortListing = useListingLayoutIsShortSelector();
  const popoverVisibilityState = useToggleState();
  const { tradingLink } = useCardOfferDataContext();

  /**
   * @todo Удалить фича-тогл
   * @description Данный функционал появился в задаче CD-187914, будет удалён в задаче CD-188067
   */
  const electronicTradingEnabled = config.getStrict<boolean>('Commercial.ElectronicTrading.Enabled');

  let content: JSX.Element;

  const callToActionButton = ((): JSX.Element => {
    if (electronicTradingEnabled && tradingLink) {
      return <JoinElectronicTradingButtonContainer buttonText="К торгам" />;
    }

    return (
      <div className={styles['phone-button-wrapper']}>
        <PublisherPhoneButtonContainer displayPhonesOptions={displayPhonesOptions} />
      </div>
    );
  })();

  if (isShortListing) {
    content = (
      <>
        <div onClick={stopPropagation}>{callToActionButton}</div>
        <div className={styles['container-short']} onClick={stopPropagation}>
          <FavoriteContainer isVisible={popoverVisibilityState.state} tooltipPlacement="top" />
          <More popoverPlacement="top-end" popoverVisibilityState={popoverVisibilityState} tooltipPlacement="top">
            <ChatButtonNarrowCard />
            <MoreItemComplaintContainer />
          </More>
          <ComplaintFlow />
        </div>
      </>
    );
  } else {
    content = (
      <div className={styles['container']} onClick={stopPropagation}>
        <FavoriteContainer />
        <ComplaintContainer />
        <ComplaintFlow />
      </div>
    );
  }

  return (
    <ErrorLogContainer level="error">
      <CardComplaintContextProvider value={complaintContextValue}>{content}</CardComplaintContextProvider>
    </ErrorLogContainer>
  );
}, 'Controls');
